import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// import { ReactComponent as ExportIcon } from '../../../../assets/icons/export.svg';
// import { ReactComponent as FilterClose } from '../../../../assets/icons/filter-close.svg';
// import { ReactComponent as Filter } from '../../../../assets/icons/filter.svg';
import { ReactComponent as SearchIcon } from '../../../../assets/icons/search.svg';
import { ReactComponent as SizeChangeIcon } from '../../../../assets/icons/size-change-icon.svg';
// import { DeviceDetailsProperties } from '../../../../interface/device-management.interface';
import { DeviceDetailsProperties } from '../../../../interface/device-management.interface';
import { useAppSelector } from '../../../../redux/hooks';
import MyButton from '../../../../shared-components/button/Button';
import CustomInput from '../../../../shared-components/custom-input/CustomInput';
import device from '../../../../utils/api/device';

/**
 * Function to get the value from nested object
 * @param object
 * @param keys
 * @returns
 */
function getValue(object: any, keys: string[]) {
  return keys.reduce(
    (accumulator, key) => (accumulator && accumulator[key] !== undefined ? accumulator[key] : '-'),
    object,
  );
}

/**
 * Component to display device data with filters
 * @returns
 */
function DeviceData() {
  const { t } = useTranslation('devices');
  const { selectedChargingPoint } = useAppSelector((state) => state.device);
  const [selectedDeviceGeneralData, setSelectedDeviceGeneralData] =
    useState<DeviceDetailsProperties>({
      connectors: [],
    });
  const [selectedDeviceEnelData, setSelectedDeviceEnelData] = useState<any>({});
  const [tableSize, setTableSize] = useState<'small' | 'medium' | 'large'>('small');

  const [searchValue, setSearchValue] = useState<string>('');

  const deviceGeneralDetails = [
    {
      id: 1,
      label: t('name'),
      key: 'chargingPointName',
    },
    {
      id: 2,
      label: t('deviceId'),
      key: 'chargingPointSn',
    },
    {
      id: 3,
      label: t('deviceSNo'),
      key: 'chargingPointSn',
    },
    {
      id: 6,
      label: t('chargePointVendor'),
      key: 'chargePointVendor',
    },
    {
      id: 7,
      label: t('firmwareVersion'),
      key: 'firmwareVersion',
    },
    {
      id: 8,
      label: t('deviceModel'),
      key: 'chargePointModel',
    },
    {
      id: 9,
      label: t('maxPowerAvailable'),
      key: 'maxPowerAvailable',
    },
  ];

  const predefinedKeys = [
    { key: ['sn'], label: t('serialNumber') },
    { key: ['tenantId'], label: t('tenantId') },
    { key: ['powerMaxPoc'], label: t('maxPowerPoc') },
    { key: ['isReachableState'], label: t('reachableState') },
    { key: ['acElectricCurrent', 'voltage'], label: t('acVoltage') },
    { key: ['acElectricCurrent', 'phaseType'], label: t('acPhaseType') },
    {
      key: ['csTechnicalConfiguration', 'address', 'completeAddress'],
      label: t('completeAddress'),
    },
    { key: ['csTechnicalConfiguration', 'address', 'countryCode'], label: t('countryCode') },
    { key: ['csTechnicalConfiguration', 'address', 'regionCode'], label: t('regionCode') },
    { key: ['csTechnicalConfiguration', 'address', 'postalCode'], label: t('postalCode') },
    { key: ['csTechnicalConfiguration', 'address', 'position', 'type'], label: t('positionType') },
    {
      key: ['csTechnicalConfiguration', 'address', 'position', 'coordinates', '0'],
      label: t('longitude'),
    },
    {
      key: ['csTechnicalConfiguration', 'address', 'position', 'coordinates', '1'],
      label: t('latitude'),
    },
    { key: ['isRVxG'], label: t('rvxg') },
    { key: ['rvxgAlgorithm'], label: t('rvxgAlgorithm') },
    { key: ['rvxgLoadAreaId'], label: t('rvxgLoadAreaId') },
    { key: ['rvxgLoadAreaName'], label: t('rvxgLoadAreaName') },
  ];

  /**
   * General details
   * @param chargingPointSn
   */
  const handleFetchDeviceGeneralDetails = async (id: string) => {
    try {
      const response = await device.fetchChargingPointGeneralDetails(id);
      setSelectedDeviceGeneralData({
        ...response.data,
        maxPowerAvailable: `${response.data?.maximumOutputPower} ${response.data?.maximumOutputPowerUnit}`,
      });
      setSelectedDeviceEnelData(response.data.enelData || {});
    } catch (error) {
      console.log(error);
    }
  };

  /**
   * Highlight the searched text
   * @param text
   * @returns
   */
  const highlightText = (text: string): React.ReactNode => {
    if (!searchValue.trim()) return text;

    const regex = new RegExp(`(${searchValue})`, 'gi');
    const parts = text.split(regex);

    return parts.map((part, index) =>
      regex.test(part) ? (
        <span key={index} className="highlight">
          {part}
        </span>
      ) : (
        part
      ),
    );
  };

  /**
   * Function to handle table size change
   */
  const handleChangeTableSize = () => {
    if (tableSize === 'small') {
      setTableSize('medium');
    } else if (tableSize === 'medium') {
      setTableSize('large');
    } else if (tableSize === 'large') {
      setTableSize('small');
    }
  };

  useEffect(() => {
    if (selectedChargingPoint) {
      handleFetchDeviceGeneralDetails(selectedChargingPoint.id);
    }
  }, [selectedChargingPoint]);

  return (
    <div className="device-data-wrap">
      <div className="device-data-filters">
        <div className="device-data-search">
          <MyButton
            label=""
            buttonType="primary-outline"
            onClickFunc={handleChangeTableSize}
            svgIcon={<SizeChangeIcon />}
          />{' '}
          {searchValue === 'kathiravan' && (
            <CustomInput
              type="text"
              name="search"
              value={searchValue}
              placeholder={t('searchHere')}
              onChangeValue={(name: string, value: string | number) => {
                setSearchValue(value.toString());
              }}
              svgIcon={<SearchIcon />}
            />
          )}
        </div>

        {/* <MyButton
          label=""
          buttonType="primary-outline"
          onClickFunc={() => {}}
          svgIcon={<Filter />}
        />
        <MyButton
          label="Clear Filter"
          buttonType="primary-outline"
          onClickFunc={() => {}}
          svgBackIcon={<FilterClose />}
        /> */}
        {/* <MyButton
          label="Export"
          buttonType="primary-outline"
          onClickFunc={() => {}}
          svgBackIcon={<ExportIcon />}
        /> */}
      </div>
      <div className="device-data-container">
        {deviceGeneralDetails.map((generalDetail) => (
          <div className={`each-device-data ${tableSize}`}>
            <h6>{highlightText(generalDetail.label)}</h6>
            <p>
              {highlightText(
                String(
                  selectedDeviceGeneralData[generalDetail.key as keyof DeviceDetailsProperties] ||
                    '-',
                ),
              )}
            </p>
          </div>
        ))}
        {predefinedKeys.map((dataField) => (
          <div className={`each-device-data ${tableSize}`}>
            <h6>{highlightText(dataField.label)} :</h6>
            <p>{highlightText(getValue(selectedDeviceEnelData, dataField.key))}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default DeviceData;
